import React from 'react'
import loadable from '@loadable/component'

export { type FormContextType, type DataType, type IFormDataVals } from './types'
export { Form } from './components/Form'
export { ModalForm } from './components/ModalForm'
export { Text } from './components/Text'
export { TextArea } from './components/TextArea'
export { Password } from './components/Password'
export { Combo } from './components/Combo'
export { CheckBox } from './components/CheckBox'
export { Countries } from './components/Countries'
export { DatePicker } from './components/DatePicker'
export { FileUpload } from './components/FileUpload'
export { Monaco } from './components/Monaco'
export { useForm } from './hooks/useForm'
export { useUrlFrom } from './hooks/useUrlFrom'
export { useOnChange } from './hooks/useOnChange'

const RichText = loadable( async () => {
    const { RichText } = await import( './components/RichText' ) 
    return RichText
}, { ssr: false } )
export { RichText }
